export default {
  operation: 'Operation',
  total: 'Total',
  fail: 'Fail',
  status: 'Status',
  updateTime: 'Update Time',
  refresh: 'Refresh',
  success: 'Success',
  sendToAnt: 'Send To Ant',
  history: 'Recent 30 days history',
  refreshTime: 'Page refresh time: ',
  apiType: 'API Type',
  plant: 'Plant',
  failCount: 'Fail Count',
  lastUpdateTime: 'Last Update Time',
  errorCode: 'Error Code',
  errorMessage: 'Error Message',
  payloadStorePath: 'Payload Store Path',
  createTime: 'Create Time',
  download: 'Download',
  paramEmpty: 'Param can’t be empty',
  apiExist: 'Api invocation log not exist',
  taskExist: 'Task not exists',
  notSupportWms: 'Not support wms',
  serverError: 'gc-nfc-service internal server error',
  APIDashboardLog: 'API Dashboard Log'
}
